/*
 * COPYRIGHT (c) 2023
 * HONEYWELL INC.,
 * ALL RIGHTS RESERVED
 *
 * This software is a copyrighted work and/or information protected as a trade secret.
 * Legal rights of Honeywell Inc. in this software is distinct from ownership of any medium
 * in which the software is embodied. Copyright or trade secret notices included must be
 * reproduced in any copies authorized by Honeywell Inc.
 *
 */

import React, { useState, useEffect } from 'react';
import { useTranslation } from '@scuf/localization';
import descriptors from '../../../../locales/en-US/descriptors';
import { isObjectOrArrayAndEmpty } from '../../../shared/Utils/Utils';
import ConnectionError from '../../../shared/ErrorComponents/ConnectionError';
import withLoadingStatus from '../../../shared/StatusWrappers/LoadingStatus';
import withErrorStatus from '../../../shared/StatusWrappers/ErrorStatus';
import AccountDropdown from '../../../shared/UtilityBillBreakdown/AccountDropdown/AccountDropdown';
import {
  IAccount,
  IAny,
  IUtilityAccountPerformanceData,
  IUtilityAccountPerformanceProps,
  IUtilityAccountProps
} from '../../../DashboardKPIWidgets/IEnergyManagementProps';

const UtilityAccountDropdownContent = (props: IAny) => {
  const d = descriptors.energyManagement;
  const [t] = useTranslation();
  const { data, onRefresh, accountNumberUpdateCallBack } = props;
  if (isObjectOrArrayAndEmpty(data)) {
    return (
      <div className="errorDisplay">
        <ConnectionError
          title={t(d.CONNECTIONERRORTITLE)}
          message={t(d.CONNECTIONERROR)}
          onRefresh={onRefresh}
        />
      </div>
    );
  }
  return (
    <div>
      <AccountDropdown
        tableLoader={props.tableLoader}
        graphLoader={props.graphLoader}
        data={data}
        onApply={accountNumberUpdateCallBack}
      />
    </div>
  );
};

const UtilityAccountDropdownWithLoader = withLoadingStatus(
  withErrorStatus(UtilityAccountDropdownContent)
);

const UtilityAccountDropdown = (props: IUtilityAccountPerformanceData) => {
  const [t] = useTranslation();
  const d = descriptors.energyManagement;
  const {
    accountData,
    accountNumberUpdateCallBack,
    selectedAccountNumber
  } = props;

  const [data, setData] = useState({} as IAccount[]);

  useEffect(() => {
    if (accountData && accountData.length > 0) {
      const uniqueAccountNumbers = accountData.filter(
        (value: string, index: number, array: string | any[]) =>
          array.indexOf(value) === index
      );
      accountNumberUpdateCallBack(uniqueAccountNumbers);
      const updatedAcountData = uniqueAccountNumbers?.map((item: IAccount) => {
        return {
          accountNumber: item,
          isSelected: true
        };
      });
      setData(updatedAcountData);
    }
  }, [accountData]);

  useEffect(() => {
    if (accountData && accountData.length > 0) {
      const uniqueAccountNumbers = accountData.filter(
        (value: string, index: number, array: string | any[]) =>
          array.indexOf(value) === index
      );
      // accountNumberUpdateCallBack(uniqueAccountNumbers);
      const updatedAcountData = uniqueAccountNumbers?.map((item: IAccount) => {
        return {
          accountNumber: item,
          isSelected: selectedAccountNumber.includes(item)
        };
      });
      setData(updatedAcountData);
    }
  }, [selectedAccountNumber]);

  return (
    <>
      {data && data.length > 0 && (
        <AccountDropdown
          tableLoader={props.tableLoader}
          graphLoader={props.graphLoader}
          data={data}
          onApply={accountNumberUpdateCallBack}
        />
      )}
    </>
  );
};
export default UtilityAccountDropdown;
